import React, { Component } from 'react';
import loadjs from 'loadjs';
import { Link } from 'react-router-dom';

class Blog extends Component {
    componentDidMount() {
        loadjs("/js/main.js")
    }

    render() {
        return(
            <React.Fragment>
                <section className="home-slider owl-carousel">
                <div className="slider-item" style={{"backgroundImage": "url('/images/bg_3.jpg')"}} data-stellar-background-ratio="0.5">
                    <div className="overlay"></div>
                    <div className="container">
                    <div className="row slider-text justify-content-center align-items-center">

                        <div className="col-md-7 col-sm-12 text-center ftco-animate">
                            <h1 className="mb-3 mt-5 bread">Blog</h1>
                            <p className="breadcrumbs"><span className="mr-2"><Link to="/">Home</Link></span> <span>Blog</span></p>
                        </div>

                    </div>
                    </div>
                </div>
                </section>

                <section className="ftco-section">
                <div className="container">
                    <div className="row d-flex">
                    <div className="col-md-4 d-flex ftco-animate">
                        <div className="blog-entry align-self-stretch">
                        <Link to="/blog-single" className="block-20" style={{"backgroundImage": "url('/images/image_1.jpg')"}}></Link>
                        <div className="text py-4 d-block">
                            <div className="meta">
                            <div><a href="#">Sept 28, 2018</a></div>
                            <div><a href="#">Admin</a></div>
                            <div><a href="#" className="meta-chat"><span className="icon-chat"></span> 3</a></div>
                            </div>
                            <h3 className="heading mt-2"><a href="#">Coffee Testing Day</a></h3>
                            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex ftco-animate">
                        <div className="blog-entry align-self-stretch">
                        <Link to="/blog-single" className="block-20" style={{"backgroundImage": "url('/images/image_2.jpg')"}}></Link>
                        <div className="text py-4 d-block">
                            <div className="meta">
                            <div><a href="#">Sept 28, 2018</a></div>
                            <div><a href="#">Admin</a></div>
                            <div><a href="#" className="meta-chat"><span className="icon-chat"></span> 3</a></div>
                            </div>
                            <h3 className="heading mt-2"><a href="#">Coffee Testing Day</a></h3>
                            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex ftco-animate">
                        <div className="blog-entry align-self-stretch">
                        <Link to="/blog-single" className="block-20" style={{"backgroundImage": "url('/images/image_3.jpg')"}}></Link>
                        <div className="text py-4 d-block">
                            <div className="meta">
                            <div><a href="#">Sept 28, 2018</a></div>
                            <div><a href="#">Admin</a></div>
                            <div><a href="#" className="meta-chat"><span className="icon-chat"></span> 3</a></div>
                            </div>
                            <h3 className="heading mt-2"><a href="#">Coffee Testing Day</a></h3>
                            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex ftco-animate">
                        <div className="blog-entry align-self-stretch">
                        <Link to="/blog-single" className="block-20" style={{"backgroundImage": "url('/images/image_4.jpg')"}}></Link>
                        <div className="text py-4 d-block">
                            <div className="meta">
                            <div><a href="#">Sept 28, 2018</a></div>
                            <div><a href="#">Admin</a></div>
                            <div><a href="#" className="meta-chat"><span className="icon-chat"></span> 3</a></div>
                            </div>
                            <h3 className="heading mt-2"><a href="#">Coffee Testing Day</a></h3>
                            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex ftco-animate">
                        <div className="blog-entry align-self-stretch">
                        <Link to="/blog-single" className="block-20" style={{"backgroundImage": "url('/images/image_5.jpg')"}}></Link>
                        <div className="text py-4 d-block">
                            <div className="meta">
                            <div><a href="#">Sept 28, 2018</a></div>
                            <div><a href="#">Admin</a></div>
                            <div><a href="#" className="meta-chat"><span className="icon-chat"></span> 3</a></div>
                            </div>
                            <h3 className="heading mt-2"><a href="#">Coffee Testing Day</a></h3>
                            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex ftco-animate">
                        <div className="blog-entry align-self-stretch">
                        <Link to="/blog-single" className="block-20" style={{"backgroundImage": "url('/images/image_6.jpg')"}}></Link>
                        <div className="text py-4 d-block">
                            <div className="meta">
                            <div><a href="#">Sept 28, 2018</a></div>
                            <div><a href="#">Admin</a></div>
                            <div><a href="#" className="meta-chat"><span className="icon-chat"></span> 3</a></div>
                            </div>
                            <h3 className="heading mt-2"><a href="#">Coffee Testing Day</a></h3>
                            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="row mt-5">
                    <div className="col text-center">
                        <div className="block-27">
                        <ul>
                            <li><a href="#">&lt;</a></li>
                            <li className="active"><span>1</span></li>
                            <li><a href="#">2</a></li>
                            <li><a href="#">3</a></li>
                            <li><a href="#">4</a></li>
                            <li><a href="#">5</a></li>
                            <li><a href="#">&gt;</a></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                </div>
                </section>
            </React.Fragment>
        )
    }
}

export default Blog;